<script setup lang="ts">
const FEES_INFO = ['serviceFee', 'taxes', 'smallOrderFee']

const emit = defineEmits(['toggle-modal'])

const { t } = useLocale()

const itemTitle = (index: number, item: string) =>
  `${index + 1}. ${t(`shoppingCart.feesInfo.${item}.name`)}`
</script>

<template>
  <ModalCenter :add-close-button="false" :content-full="true">
    <template #header>
      <CloseIcon
        width="16"
        height="16"
        class="ml-4 mt-2 cursor-pointer md:-ml-2"
        @click="emit('toggle-modal')"
      />
    </template>
    <template #content>
      <div class="mx-6 mt-6 flex flex-col gap-6 md:mx-12 md:mt-12">
        <h1 class="text-2xl font-bold">{{ t('shoppingCart.feesInfo.title') }}</h1>
        <section v-for="(item, index) in FEES_INFO" :key="index">
          <article>
            <h3 class="font-bold">{{ itemTitle(index, item) }}</h3>
            <p>{{ `${t(`shoppingCart.feesInfo.${item}.info`)}` }}</p>
          </article>
        </section>
      </div>
    </template>
  </ModalCenter>
</template>
